import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./index.css";

// Lazy loaded components
const Home = lazy(() => import("./components/Home"));
const About = lazy(() => import("./components/About"));
const VisionMission = lazy(() => import('./components/Vision_Mission'));
const RTIInfo = lazy(() => import('./components/RTIInfo'));
const AccountsSection = lazy(() => import('./components/AccountsSection'));
const ComputerSection = lazy(() => import('./components/ComputerSection'));
const ConfidentialSection = lazy(() => import('./components/ConfidentialSection'));
const DispatchSection = lazy(() => import('./components/DispatchSection'));
const EstablishmentSection = lazy(() => import('./components/EstablishmentSection'));
const TechnicalAcademicSection = lazy(() => import('./components/TechnicalAcademicSection'));
const InstituteAbstract = lazy(() => import('./components/InstituteAbstract'));
const DiplomaInstitute = lazy(() => import('./components/DiplomaInstitute'));
const Scholarship = lazy(() => import('./components/Scholarship'));
const Links = lazy(() => import('./components/Links'));
const ContactUs = lazy(() => import('./components/ContactUs'));
const GrievanceForm = lazy(() => import('./components/GrievanceForm'));
const Circular = lazy(() => import('./components/Circular'));
const Sitemap = lazy(() => import('./components/Sitemap'));
const  PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const  BrokenPolicy = lazy(() => import('./components/BrokenPolicy'));
const DegreeInstitues = lazy(() => import('./components/DegreeInstitues'));
const PostGraduation =lazy(()=>import('./components/PostGraduation'));
function App() {
  return (
    <Router>
      <div className="App">
        <Header />

        {/* Suspense fallback - shows while component is loading */}
        <Suspense fallback={<div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/rtinew" element={<RTIInfo />} />
            <Route path="/accounts-section" element={<AccountsSection />} />
            <Route path="/computer" element={<ComputerSection />} />
            <Route path="/confidential" element={<ConfidentialSection />} />
            <Route path="/dispatch" element={<DispatchSection />} />
            <Route path="/establishment-section" element={<EstablishmentSection />} />
            <Route path="/technical-section" element={<TechnicalAcademicSection />} />
            <Route path="/institute-abstract" element={<InstituteAbstract />} />
            <Route path="/diploma-inst" element={<DiplomaInstitute />} />
            <Route path="/scholarships" element={<Scholarship />} />
            <Route path="/useful-links" element={<Links />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/grievance" element={<GrievanceForm />} />
            <Route path="/circular" element={<Circular />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/broken-link" element={<BrokenPolicy />} />
            <Route path="/degree-institute" element={<DegreeInstitues />} />
            <Route path="/postGraduation" element={<PostGraduation />} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
